<template>
  <div class="home-box">
    <h2 class="gray_dk--text">Club Overview</h2>
    <v-row>
      <v-col cols="12" xs="6" md="3" class="h-100">
        <v-card height="100%">
          <div class="text-center">
            <h3 class="gray--text">Total Points</h3>
            <div class="time-track">
              <span class="club-points">{{ total }}</span>
            </div>
            <div class="question-count2">
              <p class="question-stat">
                {{ project }}
                <span>Services</span>
              </p>
              <p class="question-stat">
                {{ admin }}
                <span>Administration</span>
              </p>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" xs="6" md="3" class="h-100">
        <v-card height="100%" :to="'/members'">
          <div class="text-center">
            <h3 class="gray--text">Club Members</h3>
            <div class="time-track">
              <span class="club-members">{{ count }}</span>
            </div>
            <div class="question-count2">
            <p class="question-stat">
              {{newMembers}}
              <span>New</span>
            </p>
            <p class="question-stat">
              {{dropMembers}}
              <span>Drop</span>
            </p>
          </div>
          </div>
          
        </v-card>
      </v-col>
      <v-col cols="12" xs="6" md="3" class="h-100">
        <v-card height="100%">
          <div class="text-center">
            <h3 class="gray--text">Service Projects</h3>
            <div class="time-track">
              <span class="service-project-count">{{projectCount}}</span>
            </div>
          </div>
          <div class="question-count2">
            <p class="question-stat">
              {{projectMonthlyCount}}
              <span>This Month</span>
            </p>
            <p class="question-stat">
              {{projectCount}}
              <span>This Year</span>
            </p>
          </div>
        </v-card>
      </v-col>
      <div class="col-md-3 col-xs-12">
        <v-card height="100%">
          <div class="text-center">
            <h3 class="gray--text">Meetings</h3>
            <div class="time-track">
              <span class="club-meetings">{{meetingCount}}</span>
            </div>
          </div>
          <div class="question-count2">
            <p class="question-stat">
              {{meetingMonthlyCount}}
              <span>This Month</span>
            </p>
            <p class="question-stat">
              {{meetingCount}}
              <span>This Year</span>
            </p>
          </div>
        </v-card>
      </div>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { CommonService } from "../../services/common-service.js";
import { checkError } from "@/config/errors.js";
const humanFormat = require("human-format");
export default {
  name: "StudentRanks",
  props: ["count"],
  components: {},
  data: () => ({
    loading: false,
    myRankLoad: false,
    statLoading: false,
    statisticsLoad: false,
    model: null,
    myRank: [],
    myStats: [],
    userRanks: [],
    defaultRate: 0,
    correct: 0,
    total: 0,
    admin: 0,
    project: 0,
    projectCount: 0,
    projectMonthlyCount: 0,
    meetingCount: 0,
    meetingMonthlyCount: 0,
    newMembers: 0,
    dropMembers: 0,
    chart: [],
    category: [],
    defaultImage: require("@/assets/img/avatar.svg"),
  }),

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  mounted() {
    this.getPoints();
  },

  watch: {},

  methods: {
    getPoints() {
      this.loading = true;
      CommonService.getClubPoints()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.total = humanFormat(
              Number(response.data.data.project) +
                Number(response.data.data.admin)
            );

            this.admin = humanFormat(Number(response.data.data.admin));
            this.project = humanFormat(Number(response.data.data.project));
            this.projectCount =humanFormat(Number(response.data.data.projectCount));
            this.projectMonthlyCount = humanFormat(Number(response.data.data.projectMonthlyCount));
            this.meetingMonthlyCount = humanFormat(Number(response.data.data.meetingMonthlyCount));
            this.meetingCount = humanFormat(Number(response.data.data.meetingCount));
            this.newMembers = humanFormat(Number(response.data.data.newMembers));
            this.dropMembers = humanFormat(Number(response.data.data.dropMembers));
          }
        })
        .catch((error) => {
          this.loading = false;
          this.members = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },
};
</script>
